import { getMessage } from 'common/helpers/miscHelper';

const Footer = (props) => {
  const { settings } = props;
  return (
    <div
      className="c7-checkout__footer"
      dangerouslySetInnerHTML={{
        __html: getMessage('Checkout & Club Signup Footer', settings)
      }}
    />
  );
};
export default Footer;
